const recruiterProProfile = [
    '.experience-card', // Contact Page
];
const recruiterProBulk = [
    '.profile-list-item.hp-core-temp', // Bulk Search Page
];
export const LINKEDIN_RECRUITER_PRO_INDICATORS_BY_CONTEXT_TYPE = {
    profile: recruiterProProfile,
    bulk: recruiterProBulk,
    unknown: [...recruiterProProfile, ...recruiterProBulk],
};
